import { useState } from "react";
import { extraApi } from "src/api/extra";

import { RestartAlt } from "@mui/icons-material";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
} from "@mui/material";

const RestartButton = () => {
    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleRestart = async () => {
        handleClose();
        try {
            const result = await extraApi.restartBackend();
            alert("Backend restarted successfully:\n" + result.message);
        } catch (error) {
            alert("Failed to restart backend:\n" + (error.message || JSON.stringify(error)));
        }
    };

    return (
        <>
            <IconButton onClick={handleOpen} title="Restart Backend">
                <RestartAlt />
            </IconButton>

            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="restart-dialog-title"
                aria-describedby="restart-dialog-description"
            >
                <DialogTitle id="restart-dialog-title">Neustarten ?</DialogTitle>
                <DialogContent>
                    <DialogContentText id="restart-dialog-description">
                        Sicher stellen, dass keine aktiven Exportprozesse laufen. <br />
                        <strong>Wollen Sie den Backend-Prozess wirklich neu starten?</strong>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Abbrechen
                    </Button>
                    <Button onClick={handleRestart} color="warning" variant="contained" autoFocus>
                        Neustarten
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default RestartButton;
